import { render, staticRenderFns } from "./ChiefSupervisorReportsDashboard.vue?vue&type=template&id=615d7807&"
import script from "./ChiefSupervisorReportsDashboard.vue?vue&type=script&lang=js&"
export * from "./ChiefSupervisorReportsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports